import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractItemComponent } from '@df/catalog-ui/abstract-item.component';
import { IPageDataV2 } from '@df/catalog/cms/cms-model.interface';
import { ImageModule } from '@df/module-image/image.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsPage } from '@icms/core/resource/page/icms-page';
import { LocalICmsPage } from '../../../../catalog/page/local/local-page';
import { NBlogCategoryPageType } from '../../page/category-view/cms-blog-page-category-view.component';
import { NBlogPostPageType } from '../../page/post-view/cms-blog-page-post-view.component';

@Component({
    selector: 'cms-blog-content-blog-card',
    templateUrl: './cms-blog-content-blog-card.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TranslationModule, HrefComponent, CommonModule, ImageModule]
})
export class CmsBlogContentBlogCardComponent extends AbstractItemComponent<LocalICmsPage<IPageDataV2<NBlogPostPageType.ITypeData>>> {
    type = ICmsPage.type;
    protected tagCategories?: LocalICmsPage<IPageDataV2<NBlogCategoryPageType.ITypeData>>[];

    get typeData() {
        return this?.model?.data?.typeData;
    }

    protected override onModelChange(): void {
        this.tagCategories = this.model?.getBlogPostCategories()?.slice(0, 3);
        return super.onModelChange();
    }
}
